export { default } from "./ProductGridSkeleton.jsx";
